import React, { createContext, useContext, useState } from 'react';

export interface CommunicationStats {
  inboxCount: number;
  needsReplyCount: number;
  recentCallsCount: number;
}

interface CommunicationStatsContextValue {
  stats: CommunicationStats;
  setStats: (stats: CommunicationStats) => void;
}

const CommunicationStatsContext = createContext<CommunicationStatsContextValue>({
  stats: { inboxCount: 0, needsReplyCount: 0, recentCallsCount: 0 },
  setStats: () => {},
});

export const CommunicationStatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [stats, setStats] = useState<CommunicationStats>({
    inboxCount: 0, needsReplyCount: 0, recentCallsCount: 0,
  });
  return (
    <CommunicationStatsContext.Provider value={{ stats, setStats }}>
      {children}
    </CommunicationStatsContext.Provider>
  );
};

export const useCommunicationStats = () => useContext(CommunicationStatsContext);
